import { useData } from "../context/DataContext";
import { useGo } from "../hooks/useSiteNav";
import { C } from "../styles/theme";
import { IMG } from "../data/initialData";
import SecHdr from "../components/common/SecHdr";
import PBtn from "../components/common/PBtn";
import HeroBanner from "../components/layout/HeroBanner";

export default function Careers() {
  const { db } = useData();
  const go = useGo();
  const jobs = (db.jobs || []).filter(j => j.status === "open");

  return (
    <div style={{ background: C.bg }}>
      <HeroBanner tag="Join Our Team" title="Careers at Cyclojet Infotech" sub="Be part of a growing multi-service company with offices in Bijnor, Delhi and Mumbai." b1="View Open Positions" ob1={() => {}} img={IMG.staffing} />
      <div style={{ padding: "52px 24px" }}>
        <div style={{ maxWidth: 920, margin: "0 auto" }}>
          <SecHdr tag="Open Positions" title="Current Job Openings" sub="We are always looking for talented, passionate individuals." />
          {!jobs.length && <div style={{ textAlign: "center", padding: 44, color: C.gray, background: "#fff", borderRadius: 13 }}>No open positions right now. Check back soon!</div>}
          <div style={{ display: "flex", flexDirection: "column", gap: 13 }}>
            {jobs.map(j => (
              <div key={j.id} className="hl" style={{ background: "#fff", borderRadius: 13, padding: "18px 22px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 14, flexWrap: "wrap", boxShadow: "0 2px 12px rgba(26,60,110,.06)", border: `1px solid ${C.border}` }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <h4 style={{ fontSize: 15, fontWeight: 700, color: C.blue, marginBottom: 7 }}>{j.title}</h4>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 6 }}>{[j.dept, j.location, j.type, j.exp].map(t => <span key={t} style={{ background: C.bg, border: `1px solid ${C.border}`, padding: "2px 9px", borderRadius: 20, fontSize: 11, fontWeight: 600, color: C.gray }}>{t}</span>)}</div>
                  <div style={{ fontSize: 11.5, color: C.gray }}>Posted: {j.posted} · <strong style={{ color: C.blue }}>{j.applicants} applicants</strong></div>
                </div>
                <PBtn onClick={() => go("contact")}>Apply Now</PBtn>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
